import Vue from 'vue';

document.addEventListener('DOMContentLoaded', () => {
  const burgerMenu = document.getElementById('js-burger-menu');

  if (burgerMenu) {
    const vm = new Vue({
      delimiters: ['${', '}'],
      el: burgerMenu,
      data: {
        isOpen: false,
        topLevelGroup: null,
        secondaryLevelGroup: null,
      },
      mounted() {
        const burger = document.getElementById('js-burger');
        burger.addEventListener('click', () => {
          this.openBurgerMenu();
        });
      },
      methods: {
        setTopLevelGroup(group) {
          this.topLevelGroup = group;
        },
        setSecondaryLevelGroup(group) {
          this.secondaryLevelGroup = group;
        },

        triggerSearch() {
          // Dispatch the searchToggle custom event
          const event = new CustomEvent('searchToggle');
          document.dispatchEvent(event);
        },
        openBurgerMenu() {
          this.isOpen = true;
          document.body.classList.add('no-scroll');
          document.addEventListener('keydown', this.handleEsc);
        },
        closeBurgerMenu() {
          this.isOpen = false;
          document.removeEventListener('keydown', this.handleEsc);
          document.body.classList.remove('no-scroll');
          this.topLevelGroup = null;
          this.secondaryLevelGroup = null;
        },
        handleEsc(e) {
          if (e.keyCode === 27) {
            this.closeBurgerMenu();
          }
        },
      },
    });
  }
});
